// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-list-filter-year-topic/event-list-filter-year-topic.component.scss
// module id = 272
// module chunks = 0